import * as Styled from './GroupOrganization.styled';
import * as ReportingStyled from '../Reporting.styled';

export const groupOrganizationColumns = [
  {
    title: 'Group Name',
    dataIndex: 'group_name',
    key: 'group_name',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Group validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'group_validity',
    onHeaderCell: () => ({
      style: Styled.groupOrgHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'group_start_date',
        key: 'group_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.groupOrgStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'group_end_date',
        key: 'group_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Division Name',
    dataIndex: 'division_name',
    key: 'division_name',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Division validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'division_validity',
    onHeaderCell: () => ({
      style: Styled.groupOrgHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'division_start_date',
        key: 'division_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.groupOrgStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'division_end_date',
        key: 'division_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Region Name',
    dataIndex: 'region_name',
    key: 'region_name',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Region validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'region_validity',
    onHeaderCell: () => ({
      style: Styled.groupOrgHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'region_start_date',
        key: 'region_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.groupOrgStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'region_end_date',
        key: 'region_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Legal Entity Name',
    dataIndex: 'legal_entity_name',
    key: 'legal_entity_name',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Legal Entity validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'legal_entity_validity',
    onHeaderCell: () => ({
      style: Styled.groupOrgHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'legal_entity_start_date',
        key: 'legal_entity_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.groupOrgStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'legal_entity_end_date',
        key: 'legal_entity_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Business Unit Name',
    dataIndex: 'business_unit_name',
    key: 'business_unit_name',
    width: 200
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Business Unit validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'business_unit_validity',
    onHeaderCell: () => ({
      style: Styled.groupOrgHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'business_unit_start_date',
        key: 'business_unit_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.groupOrgStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'business_unit_end_date',
        key: 'business_unit_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.groupOrgDateHeaderStyle
        })
      }
    ]
  }
];
